import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useDispatch } from "react-redux";
import { logout } from "../../reducers/userReducer";

function Header() {
  const dispatch = useDispatch();
  return (
    <div className="w-full bg-white sticky top-0 h-12 flex items-center justify-center mb-2 z-50">
      <div>
        <img src="/logo.svg" alt="" className="h-8 object-contain" />
      </div>
      <div className="w-full max-w-7xl justify-end flex">
        <button
          onClick={() => {
            dispatch(logout());
          }}
        >
          <PowerSettingsNewIcon />
        </button>
      </div>
    </div>
  );
}

export default Header;
